import { useEffect } from "react";

const TermsOfUse = () => {
  const termsOfUseLink =
    "https://storage.googleapis.com/noki_public/Noki_%20Terms%20of%20Use.pdf";

  useEffect(() => {
    try {
      window.location.href = termsOfUseLink;
    } catch (error) {
      console.error("Redirection failed:", error);
    }
  }, []);

  return null;
};

export default TermsOfUse;